export default __webpack_public_path__ + "static/media/workplace.a7ce3222.svg";